import { render, staticRenderFns } from "./testingAlert.vue?vue&type=template&id=50599d6c&"
import script from "./testingAlert.vue?vue&type=script&lang=js&"
export * from "./testingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports